<template>
  <section class="dashboard-card">
    <header class="dashboard-card-header">
      <div class="flex items-center">
        <VSvgIcon name="account" />
        <h4 class="dashboard-card-header-heading">{{ $t('dashboard.salesRep.heading') }}</h4>
      </div>
    </header>
    <div class="px-8 py-4 bg-white">
      <div class="mb-2 text-sm font-bold">{{ salesRep.name }}</div>
      <div class="mb-2 text-sm text-ricoma-orange-100">{{ salesRep.phone }}</div>
      <div class="text-ricoma-orange-100 text-sm">{{ salesRep.email }}</div>
    </div>
  </section>
</template>

<script>
import VSvgIcon from '@/components/base/VSvgIcon';

export default {
  name: 'DashboardSalesRep',
  components: { VSvgIcon },
  props: { salesRep: Object },
};
</script>
